const initialState = {
    taskForm: JSON.parse(localStorage.getItem('taskForm')) || {},
    allTask: [],
    allTaskLinear: [],
    searchTask:[],
    searchTaskCalendar:[],
    searchTaskLinear:[],
    searchCommonTask:[],
    searchUser:[],
    clientCustomer: null,
    type_task_list: [],
    dueTask:[],
    policyDetails:null,
    error: null,
  };

  const taskReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'GET_DUE_TASK_SUCCESS':
      return {
        ...state, dueTask: action.payload, error: null};
      case 'GET_CLIENT_SUCCESS':
        return {
          ...state, clientCustomer: action.payload, error: null};
      case 'CLEAR_GET_CLIENT_SUCCESS':
        return {
          ...state, clientCustomer: [], error: null};
      case 'GET_TYPE_TASK_LIST_SUCCESS':
      return {
        ...state, type_task_list: action.payload, error: null};
      case 'SEARCH_COMMON_TASK_SUCCESS':
        return {
          ...state, searchCommonTask: action.payload, error: null};
      case 'SEARCH_TASK_LINEAR_SUCCESS':
        return { ...state, allTaskLinear: action.payload, error: null };
      case 'SEARCH_TASK_CALENDAR_SUCCESS':
        return { ...state, searchTaskCalendar: action.payload, error: null };
      case 'GET_TASK_SUCCESS':
        return { ...state, allTask: action.payload, error: null };
       case 'GET_CUSTOMER_POLICY_SUCCESS':
        return { ...state, policyDetails: action.payload, error: null };
       case "RESET_TASK_CONTENT":
      return { ...state, allTaskLinear: [] };
       case 'GET_TASK_LINEAR_SUCCESS':
        return { ...state, allTaskLinear: action.payload, error: null };
      case 'SAVE_TASK_SUCCESS':
        return { ...state, allTask: action.payload, error: null };
      case 'SEARCH_TASK_SUCCESS':
            return { ...state, allTask: action.payload, error: null };
      case 'SEARCH_USER_TASK_SUCCESS':
            return { ...state, searchUser: action.payload, error: null };
      case 'UPDATE_TASK_SUCCESS':
        return { ...state, allTask: action.payload, error: null };
      case 'DELETE_TASK_SUCCESS':
        return { ...state, allTask: action.payload, error: null, content: state.allTask.content.filter(task => task.id !== action.payload), };
      case 'SEARCH_COMMON_TASK_FAILURE':
      case 'SEARCH_TASK_LINEAR_FAILURE':
      case 'SEARCH_TASK_CALENDAR_FAILURE':
      case 'GET_TASK_FAILURE':
      case 'SAVE_TASK_FAILURE':
      case 'DELETE_TASK_FAILURE':
      case 'SEARCH_TASK_FAILURE':
      case 'UPDATE_TASK_FAILURE':
      case 'GET_CLIENT_FAILURE':
      case 'GET_DUE_TASK_FAILURE':

        return { ...state, error: action.payload };
      default:
        return state;
    }
  };

  export default taskReducer;
